import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "申請結果",
    isSum: true,
  },
  {
    key: "服務項目",
    isSum: true,
  },
];

export const AcceptCaseStatistic = {
  label: "受理案件統計",
  key: "AcceptCaseStatistic",
  path: "ServiceApplication/AcceptCaseStatistic",
  api: "TCS_V_ServiceApplication_5",
  render: (options) => (
    <Diagram.ServiceApplication.AcceptCaseStatistic {...options} />
  ),
  isPage: true,
  isRaw: true,
  page: null,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  dateRangeColumns: [{ label: "開案日期", key: "開案日期" }],
  groupColumns: [
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
  ],
  levelColumns,
  columns: [],
  createColumns: [
    ({ data }) => {
      let value = data["服務項目"];
      if (value) {
        value = value.split("#").pop();
      } else value = "無";
      data["服務項目"] = value;
    },
  ],
};
